<template>
  <div class="account-page section-main__warp">
    <ioc-table
      ref="companyTab"
      v-model="account"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @refresh-change="refreshChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAddCompany"
        >
          新增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="编辑"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleDel(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <!-- 新增/编辑/详情账户 -->
    <appPanel
      :width="840"
      class="app-panel"
      :isExpand="showCompanyPanel"
      :title="pageStates == 'add' ? '新增公司信息' : '编辑公司信息'"
      @cancel="handleCloseCompanyPanel"
    >
      <companyPanel
        ref="refCompanyPanel"
        :pageStates="pageStates"
        @save-company-info="saveCompanyInfo"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleCloseCompanyPanel"
          type="info"
          :loading="subLoading"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="subLoading"
          @click="handleSaveCompanyPanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api";
import companyPanel from "../components/companyPanel";
import tableOption from "../const/crud/company.js";
import utils from "@src/common/utils";
import { Bus } from "$utils";
import appPanel from "@src/components/business/app-panel/index";
export default {
  components: {
    companyPanel,
    appPanel,
  },
  data() {
    return {
      pageStates: "add",
      showCompanyPanel: false,
      codeType: 1,
      showAuthPanel: false,
      accountGroupList: [],
      reservedAccount: [],
      accountNumber: "",
      searchParams: {},
      dialogVisible: false,
      transferShow: false,
      loading: true,
      type: "",
      account: {},
      tableData: Object.freeze([]),
      page: {
        pageNum: 1,
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_pageSize") || 10,
      },
      option: tableOption(this),
      types: "",
      typeOptions: [
        {
          label: "优合公司",
          value: "1",
        },
        {
          label: "第三方公司",
          value: "2",
        },
        {
          label: "锁定",
          value: 3,
        },
      ],
      accountTypeDisabled: false,
      subLoading: false,
    };
  },
  mounted() {
    this.refreshChange(this.page);
  },
  methods: {
    saveCompanyInfo(params) {
      this.subLoading = true;
      let url = api.company.addCustomCompany;
      if (params.companyCode) {
        // 编辑
        url = api.company.updateCustomCompany;
      }
      this.$fetch(url, {
        ...params,
      }).then((res) => {
        this.subLoading = false;
        if (res && res.success) {
          this.$message.success(params.companyCode ? "编辑成功" : "新增成功");
          // 重置列表查询条件
          // this.getResetList();
          this.$refs.companyTab.reset();
          this.page.pageNum = 1;
          this.page.currentPage = 1;
          this.page.pageSize = utils.Cache.get("CURRENT_pageSize") || 10;
          this.handleCloseCompanyPanel();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleCloseCompanyPanel() {
      this.$refs.refCompanyPanel.handleRestForm();
      this.showCompanyPanel = false;
      // this.$nextTick(() => {
      // });
      // this.$nextTick(() => {
      //   this.$refs.refCompanyPanel.$refs.personTable.templateRadio = '';
      // });
    },
    handleSaveCompanyPanel() {
      this.$refs.refCompanyPanel.submit();
    },
    handleSearchReset() {
      this.getResetList();
    },
    getResetList() {
      console.log("-重置查询-");
      this.searchParams = {
        companyName: undefined,
        companyType: undefined,
      };
      console.log("-11-", this.searchParams);
      const self = this;
      this.$fetch(
        api.company.queryCustomCompany,
        Object.assign({
          pageNumber: 1,
          pageSize: 10,
        })
      ).then((response) => {
        if (!response.success) {
          self.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        self.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        self.page.total = response.returnObj ? response.returnObj.total : 0;
        self.page.currentPage = response.returnObj
          ? response.returnObj.pageNum
          : 1;
        self.page.pageNum = response.returnObj ? response.returnObj.pageNum : 1;
        self.page.pageSize = response.returnObj
          ? response.returnObj.pageSize
          : 10;
      });
    },
    getList(page) {
      const self = this;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$fetch(
        api.company.queryCustomCompany,
        Object.assign(
          {
            pageNumber: page.pageNum,
            pageSize: page.pageSize,
          },
          this.searchParams
        )
      ).then((response) => {
        loading.close();
        if (!response.success) {
          // self.$message.error(response.msgContent)
          self.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        self.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        self.page.total = response.returnObj ? response.returnObj.total : 0;
        self.page.currentPage = response.returnObj
          ? response.returnObj.pageNum
          : 1;
        self.page.pageNum = response.returnObj ? response.returnObj.pageNum : 1;
        self.page.pageSize = response.returnObj
          ? response.returnObj.pageSize
          : 10;
      });
    },
    refreshChange(page) {
      this.getList(page);
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.refreshChange(this.page);
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page);
    },
    handleSearchChange(param) {
      console.log("-查询-param:-", param);
      this.page.pageNum = 1;
      if (!param.companyName && !param.companyType) {
        this.searchParams = {};
        console.log("--111-");
      } else {
        console.log("-22--");
        this.searchParams = Object.assign({}, param);
      }
      this.getList(this.page);
    },
    //新增公司信息
    handleAddCompany() {
      this.showCompanyPanel = true;
      this.pageStates = "add";
      this.$nextTick(() => {
        this.$refs.refCompanyPanel.$refs.refForm.clearValidate();
      });
    },
    handleEdit(row, index) {
      this.pageStates = "edit";
      this.showCompanyPanel = true;
      this.$refs.refCompanyPanel.handleSetForm(row);
    },
    handleDel(row) {
      const params = {
        companyCode: row.companyCode,
      };
      this.$confirm("您确定删除该公司信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.company.deleteCustomCompany, params).then(
          (response) => {
            // this.tableData.splice(index, 1)
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.prompt,
                type: "error",
                duration: 2000,
              });
            }
            this.$refs.companyTab.reset();
            // this.getResetList();
          }
        );
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.el-select {
  width: 100%;
}
</style>
